import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { isEmpty,isUndefined } from 'lodash';
import Chip from '@material-ui/core/Chip';
import {getKundKontakter} from 'actions'
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({accountsData,auth}) {
    const { Userlista,MyOfficeType,KontakterList,Kontorlista } = accountsData;
    const { authUser } = auth;
    return {
        Userlista,authUser,MyOfficeType,KontakterList,Kontorlista
    };
}

function mapDispatchToProps(dispatch) {
    return {
      getKundKontakter: (userid,AFid,Orgnr) => dispatch(getKundKontakter(userid,AFid,Orgnr)),
    };
}

class SelectMultiMedArbetare extends Component {
    state={
        MedArbetare:this.props.MedArbetare
    }
    componentDidUpdate=()=>{
      if(this.state.MedArbetare !== this.props.MedArbetare){
        this.setState({
            MedArbetare:this.props.MedArbetare
        })
      }
    }
    componentDidMount=()=>{
      if(!isUndefined(this.props.isFrom)){
        if(!isUndefined(this.props.KundOrgnr)){
          const userid = this.props.authUser.user_id
          const Afid = this.props.authUser.user_Afid
          this.props.getKundKontakter(userid,Afid, this.props.KundOrgnr)
        }
      }
    }
    onChangeHandle=(e)=>{
      let MedArr =""
      if(!isUndefined(this.props.isAktivitet)){
        if(e.target.value.split("____").length > 1){
          if(isUndefined(this.props.isFrom)){
            MedArr = this.state.MedArbetare.concat(e.target.value)
          }else{
            MedArr = this.state.MedArbetare.concat({email:e.target.value})
          }
          this.setState({
            MedArbetare:MedArr
          })
          this.props.onchangeHanelMedArbetare(MedArr)
        }
        else{
          if(isUndefined(this.props.isFrom)){
            MedArr = this.state.MedArbetare.concat(e.target.value)
          }else{
            MedArr = this.state.MedArbetare.concat({email:e.target.value})
          }
          this.setState({
            MedArbetare:MedArr
          })
          this.props.onchangeHanelMedArbetare(MedArr)
        }
      }else{
        if(isUndefined(this.props.isFrom)){
          MedArr = this.state.MedArbetare.concat(e.target.value)
        }else{
          MedArr = this.state.MedArbetare.concat({email:e.target.value})
        }
        this.setState({
          MedArbetare:MedArr
        })
        this.props.onchangeHanelMedArbetare(MedArr)
      }      
    }
    handleChipDelete=(chipId)=>{
        let MedArr = this.state.MedArbetare.filter((n)=>{
            if(parseInt(n) !== parseInt(chipId) && n !== chipId){
                return n
            }
        })
        console.log(MedArr)
        this.setState({
            MedArbetare:MedArr
          })
        this.props.onchangeHanelMedArbetare(MedArr)
    }
    getEmailLabel = (email)=>{
      if(email.split("____").length > 1){
        let emailArr = email.split("____")
        let emailf = this.props.Kontorlista(item=>{return parseInt(item.id) === parseInt(emailArr[1])})[0].name
        return `Kontor ${emailf}`

      }
      else{
        return email
      }
    }
    render() {

        return (
            <>
            <div>
              <TextField
              variant="outlined"
              fullWidth
              label={<IntlMessages id="appKontoModule.Coworker"/>}
              size="small"
              name="MdArbetare"
              select
              value={0}
              disabled={isUndefined(this.props.disabled)?false:this.props.disabled}
              SelectProps={{native: true,}}
              InputLabelProps={{shrink: true,}}
              onChange={this.onChangeHandle}
            >
              <option key={0} disabled value={0}><IntlMessages id="Choose"/></option>
              {
                !isUndefined(this.props.isAktivitet)?
                <>
                {
                !isUndefined(this.props.Kontorlista)?
                <>
                <option key={-2} disabled value={-2}><IntlMessages id="Office"/></option>
                {
                this.props.Kontorlista.map(kontor=>{
                  return <option key={kontor.id} value={`Office____${kontor.id}`}>{kontor.stad}</option>
                })
                }
                </>
                :""
                }
                <option key={-3} disabled value={-3}><IntlMessages id="user.Role.User" /></option>
                </>
                :""
              }
              
          {            
          !isEmpty(this.props.Userlista.filter(item=>{return !isEmpty(item.UserEmail)}))?
          parseInt(this.props.authUser.user_role) > 1?
          parseInt(this.props.authUser.user_OfficeId) > 0?
          parseInt(this.props.MyOfficeType) ===2?
          this.props.Userlista.filter(item=>{return !isEmpty(item.UserEmail)})
          .filter(item=>{return item.OfficeId ===this.props.authUser.user_OfficeId })
          .map((option) => (
            isUndefined(this.props.isFrom)?
            <option key={option.id} value={option.id}>
              {option.FirstName} {option.LastName}
            </option>
            :
            <option key={option.id} value={option.UserEmail2}>
              {option.FirstName} {option.LastName}
            </option>
          ))
          :
          this.props.Userlista
          .filter(item=>{return !isEmpty(item.UserEmail)}).map((option) => (
            isUndefined(this.props.isFrom)?
            <option key={option.id} value={option.id}>
              {option.FirstName} {option.LastName}
            </option>
             :
             <option key={option.id} value={option.UserEmail2}>
               {option.FirstName} {option.LastName}
             </option>
          ))
          :
          this.props.Userlista
          .filter(item=>{return !isEmpty(item.UserEmail)}).map((option) => (
            isUndefined(this.props.isFrom)?
            <option key={option.id} value={option.id}>
              {option.FirstName} {option.LastName}
            </option>
             :
             <option key={option.id} value={option.UserEmail2}>
               {option.FirstName} {option.LastName}
             </option>
          ))
          :
          this.props.Userlista.filter(item=>{return !isEmpty(item.UserEmail)}).map((option) => (
            isUndefined(this.props.isFrom)?
            <option key={option.id} value={option.id}>
              {option.FirstName} {option.LastName}
            </option>
            :
            <option key={option.id} value={option.UserEmail2}>
              {option.FirstName} {option.LastName}
            </option>            
          )):""}
            {
              !isUndefined(this.props.isFrom)?
              isEmpty(this.props.KontakterList)?"":
              this.props.KontakterList.filter(item=>{return !isEmpty(item.Email)}).map((option) => (
                <option key={option.id} value={option.Email}>
                  {option.fname} {option.lname}
                </option>  
              ))
              :""
            }
            </TextField>  
            </div>
            {
            isUndefined(this.props.isFrom)?
            <div className="my-2">
                {!isEmpty(this.props.MedArbetare)?
                 this.props.MedArbetare.map((n)=>{
                  let filA = {}
                  if(isUndefined(this.props.isAktivitet)){
                    filA = this.props.Userlista.filter((m)=>{
                      if(parseInt(m.id) === parseInt(n)){
                          return m
                      }
                    })
                    if(!isEmpty(filA)){
                    return <>
                    <Chip 
                    label={`${filA[0].FirstName} ${filA[0].LastName}`} 
                    color="primary"
                    size="small"
                    className="mx-1"
                    
                    onDelete={()=>{
                      if(!isUndefined(this.props.disabled)){
                        if(this.props.disabled!== true){
                          this.handleChipDelete(filA[0].id)
                        }
                      }else{
                        this.handleChipDelete(filA[0].id)
                      }
                      
                    }}
                    />
                     </>   }
                  }
                  else{
                  if(n.split("____").length > 1 ){
                    filA = this.props.Kontorlista.filter((m)=>{
                      if(parseInt(m.id) === parseInt(n.split("____")[1])){
                          return m
                      }
                    })
                    if(!isEmpty(filA)){
                      return <>
                    <Chip 
                    label={`${filA[0].stad}`} 
                    color="primary"
                    size="small"
                    className="mx-1"
                    onDelete={()=>{
                      if(!isUndefined(this.props.disabled)){
                        if(this.props.disabled!== true){
                          this.handleChipDelete(`Office____${filA[0].id}`)
                        }
                      }else{
                        this.handleChipDelete(`Office____${filA[0].id}`)
                      }
                      
                    }}
                    />
                     </> }
                    
                  }else{
                    filA = this.props.Userlista.filter((m)=>{
                      if(parseInt(m.id) === parseInt(n)){
                          return m
                      }
                    })
                    console.log(filA,"DDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD")
                    if(!isEmpty(filA)){
                   return <>
                    <Chip 
                    label={`${filA[0].FirstName} ${filA[0].LastName}`} 
                    color="primary"
                    size="small"
                    className="mx-1"
                    
                    onDelete={()=>{
                      if(!isUndefined(this.props.disabled)){
                        if(this.props.disabled!== true){
                          this.handleChipDelete(filA[0].id)
                        }
                      }else{
                        this.handleChipDelete(filA[0].id)
                      }
                      
                    }}
                    />
                     </>   }
                  }
                }
                                   
                    
                })
                :""}
            </div>
            :parseInt(this.props.isFrom) === 1?
            <div className="my-2">
            {!isEmpty(this.props.MedArbetare)?
             this.props.MedArbetare.map((n)=>{

              return <>
              <Chip 
              label={`${
                this.getEmailLabel(n.email)
              }`} 
              color="primary"
              size="small"
              className="m-1"
              
              onDelete={()=>{
                if(!isUndefined(this.props.disabled)){
                if(this.props.disabled!== true){
                  this.handleChipDelete(n.email)
                }
              }else{
                this.handleChipDelete(n.email)
              }}}
              />
              </>             
                
            })
            :""}
        </div>
            :""
            }
          
            </>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(SelectMultiMedArbetare);